export enum DatiqChecklistTypes {
    Check = 'check',
    Switch = 'switch',
}

export enum DatiqChecklistErrorTypes {
    MinCheckedItems = 'minCheckedItems',
    MaxCheckedItems = 'maxCheckedItems',
}
